
import React, { useEffect, useCallback, useState } from "react";
import Select from "react-select";
import { fetchProduit, produitAdded } from "../../Redux/produitReduce";
import {
    AddedExcel,
    saveFile,
    checkProduit,
    verifEntete,
} from "../../Redux/imsnatReduce";
import { useDispatch } from "react-redux";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { verif } from "./verif_ImsNat";
import { toast, ToastContainer } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { fetchAnnee } from "../../Redux/anneeReduce";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';




function extraction_ImsNat({ client }) {

    const navigate = useHistory();
    const dispatch = useDispatch();

    const [variable, setVariable] = React.useState("");
    const [alert, setAlert] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(0);
    const [parent, setparent] = React.useState(0);
    const [entities, setEntities] = useState([]);
    const [uploadFile, setUploadFile] = React.useState()
    const [fileName, setFileName] = useState("");
    const [month, setmonth] = React.useState(0);
    const [year, setyear] = React.useState(0);
    const [readonly, setreadonly] = React.useState(0);


    const notify = (type, msg) => {
        if (type === 1)
            toast.success(<strong>{msg}</strong>);
        else
            toast.error(<strong>{msg}</strong>);
    }

    //Produit
    const [produitSelect, setProduitSelect] = React.useState([]);
    const [optionProduit, setOptionProduit] = React.useState([
        {
            value: "",
            label: "Produit",
            isDisabled: true,
        },
    ]);

    //parent
    const [optionsImsNat, setImsNatOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir un parent",
            isDisabled: true,
            style: "placeholder",
        },
    ]);
    const [ImsNatSelect, setImsNatSelect] = React.useState({
        value: 0,
        label: "veuillez choisir un parent",
        style: "placeholder",
    });

    //mois
    const [optionsmois, setmoisOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir un mois",
            isDisabled: true,
            style: "placeholder",
        },
    ]);
    const [moisSelect, setmoisSelect] = React.useState({
        value: 0,
        label: "veuillez choisir un mois",
        style: "placeholder",
    });

    //annee
    const [anneeSelect, setanneeSelect] = React.useState({
        value: 0,
        label: "veuillez choisir une année",
        style: "placeholder",
    });
    const [optionsannee, setanneeOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir une année",
            isDisabled: true,
            style: "placeholder",
        },
    ]);



    const verifmois = useCallback(
        async (b) => {

            var entities = [
                { id: 1, nom: "Janvier" }, { id: 2, nom: "Février" }, { id: 3, nom: "Mars" },
                { id: 4, nom: "Avril" }, { id: 5, nom: "Mai" }, { id: 6, nom: "Juin" },
                { id: 7, nom: "Juillet" }, { id: 8, nom: "Aout" }, { id: 9, nom: "septembre" },
                { id: 10, nom: "Octobre" }, { id: 11, nom: "Novembre" }, { id: 12, nom: "Décembre" },
            ]
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir un mois", style: "placeholder" });
            entities.forEach((a) => {
                arOption.push({ value: a.id, label: a.nom });
                if (a.id === b) {
                    setmoisSelect({ value: a.id, label: a.nom });
                    setmonth(a.id);
                }
            });
            setmoisOptions(arOption);
        },
        [dispatch]
    );


    const verifannee = useCallback(
        async (b) => {
            var ImsNat = await dispatch(fetchAnnee());
            var entities = ImsNat.payload;
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir une année", style: "placeholder" });
            const currentYear = new Date().getFullYear();
            entities.forEach((a, index) => {
                arOption.push({ value: a.id, label: a.annee });

                //if (index === entities.length - 1) {
                if (currentYear === parseInt(a.annee)) {
                    setanneeSelect({ value: a.id, label: a.annee });
                    setyear(a.annee);
                }
                //}
            });
            setanneeOptions(arOption);
        },
        [dispatch]
    );



const exportToexcel = async (info) => {
    const name = "Exemple excel ims nat";
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate()
        .toString()
        .padStart(2, '0')}`;

    const fileName = `${name} ${formattedDate}`;

    if (!info || info.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data');

    // Add headers
    const headers = Object.keys(info[0]);
    worksheet.addRow(headers);

    // Style header (optional)
    worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
    });

    // Add data rows
    info.forEach((item) => {
        worksheet.addRow(Object.values(item));
    });

    // Auto column width
    worksheet.columns.forEach((column) => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
            const length = cell.value ? cell.value.toString().length : 10;
            if (length > maxLength) {
                maxLength = length;
            }
        });
        column.width = maxLength + 2;
    });

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${fileName}.xlsx`);
};



    const fileHandler = (e) => {
        let fileObj = e.target.files[0];
        if (fileObj) {
            setUploadFile(fileObj);
            var str = fileObj.name.replace(/[^a-zA-Z0-9,;\-.!? ]/g, "");
            setFileName(str);
        }
    };


    const showTable = useCallback(async () => {
        try {
            if (fileName !== "") {
                const verificationResult = await dispatch(
                    verifEntete({
                        date: year,
                        month: month,
                        fileName: fileName,
                        id_site: client == "/medis" ? 2 : 3
                    })
                );

                if (verificationResult.payload === false) {
                    const arrayBody = await new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
        try {
            const buffer = e.target.result;

            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(buffer);

            const worksheet = workbook.worksheets[0]; // first sheet

            const rows = [];

            worksheet.eachRow({ includeEmpty: true }, (row) => {
                const rowData = row.values.slice(1); 
                // ExcelJS row.values starts at index 1
                rows.push(rowData);
            });

            resolve(verif(rows, month, anneeSelect.label));
        } catch (err) {
            console.error("Error reading Excel file:", err);
            reject(err);
        }
    };

    reader.onerror = (err) => reject(err);

    reader.readAsArrayBuffer(uploadFile);
});


                    if (arrayBody.test === false) {
                        notify(2, "Vérifier les champs de votre fichier excel");
                        window.location.reload();
                    } else {
                        notify(1, "Extraction avec succès");
                        checkProd(arrayBody.array, year);
                    }
                } else {
                    notify(2, "Déjà inséré");
                    setreadonly(0);
                    setIsLoading(0);
                    setBoutonClique(false);
                }
            } else {
                notify(2, "Vérifiez vos données");
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }, [dispatch, fileName]);



    const getproduit = useCallback(async () => {
        var type = await dispatch(fetchProduit({ client,view:"releve"  }));
        var entities = type.payload;
        var arrayOption = [];
        entities.forEach((e) => {
            arrayOption.push({ value: e.id, label: e.Designation_1, code: e.Code_PCT });
        });
        setOptionProduit(arrayOption);
    }, [dispatch]);



    function deleteLigne(nb) {
        if (entities.length > 1) {
            // Filter produitSelect
            var filteredProduitSelect = produitSelect.filter(function (value, index) {
                return index !== parseInt(nb);
            });

            // Filter entities
            var filteredEntities = entities.filter(function (entity, index) {
                return index !== parseInt(nb);
            });

            setProduitSelect(filteredProduitSelect);
            setEntities(filteredEntities);
            notify(2, "Supprimer avec succès");
        } else {
            notify(2, "Il faut contenir au moins une ligne");
        }
    }


    const checkProd = useCallback(
        async (table, year) => {
            var arrayBody = [];
            dispatch(checkProduit({ table, year })).then((rowsdes) => {
                if (rowsdes !== undefined && rowsdes.payload.length > 0) {
                    var prod = rowsdes.payload;
                    // console.log(table)
                    for (var i = 0; i < prod.length; i++) {
                        // console.log("ggg", prod[i],i)
                        if (
                            prod[i] !== null &&
                            typeof prod[i] !== "undefined" &&
                            prod[i] !== "undefined"
                        ) {
                            // console.log("des", table[i].designation, i)
                            arrayBody.push({
                                idProduit: prod[i][2],
                                designation: prod[i][0],
                                code: prod[i][3],
                                valeur: table[i].valeur
                            });
                        }
                        else {
                            // console.log("des", table[i].designation, i)
                            arrayBody.push({
                                idProduit: null,
                                designation: table[i].designation,
                                code: table[i].code,
                                valeur: table[i].valeur
                            });
                        }
                    }
                    // console.log(arrayBody)
                    setEntities(arrayBody);
                    setIsLoading(2);
                } else {
                    setEntities([]);
                }
            })
        },
        [dispatch]
    );


    const setTable = useCallback(
        async (table, init) => {
            //1 => update table ***** 0 => initialiser table
            var arrayBody = [];
            if (init === 1) {
                table.forEach((value) => {
                    arrayBody.push({
                        idProduit: value.idProduit,
                        designation: value.designation,
                        code: value.code,
                        valeur: value.valeur,
                    });
                });
                setEntities(arrayBody);
            } else {
                checkProd(table, year);
            }
        },
        [checkProd]
    );


    const removeProduit = useCallback(
        async (list, select, id) => {
            // console.log(list,select,id)
            list[id].idProduit = null;
            list[id].designation = null;
            list[id].code = "";
            select[id] = null;
            setProduitSelect(select);
            setEntities(list);
            setTable(list, 1);

            console.log(entities)
        },
        [setTable]
    );


    const saveTable = useCallback(async (entities, uploadFile, year, month, client) => {

        if (!verifierLigne(entities)) {
            return;
        }

        var verif = true;
        if (entities.length > 0) {
            entities.forEach((data) => {
                if (data.idProduit === null) verif = false;
            });
        } else {
            verif = false;
        }
        if (verif === false) {
            notify(2, "Vérifier vos données!");
        } else {
            const dataArray = new FormData();
            dataArray.append("file", uploadFile);
            dataArray.append("name", uploadFile.name);

            dispatch(saveFile(dataArray)).then((e) => {
                var filename = e.payload.filename;

                dispatch(
                    AddedExcel({
                        annee: year,
                        mois: month,
                        file: filename,
                        namefile: uploadFile.name,
                        lignes: entities, client
                    })
                ).then((e) => {
                    if (e.payload === true) {
                        notify(1, "Insertion avec succes");
                        setTimeout(() => {
                            window.location.reload();
                        }, 1300);
                    } else {
                        notify(2, "Vérifier vos données!");
                    }
                });
            });
        }
    },
        [dispatch]
    );


    function verifierLigne(entities) {

        var idProduitSet = new Set();

        for (var i = 0; i < entities.length; i++) {
            var line = entities[i];

            if (line.idProduit === null) {
                notify(2, "Veuillez choisir un produit " + (i + 1));
                return;
            }

            if (idProduitSet.has(line.idProduit)) {
                notify(2, "Le produit " + line.designation + " est dupliqué ");
                return false;
            }

            idProduitSet.add(line.idProduit);


            if (line.code === null) {
                notify(2, "Veuillez choisir un code " + (i + 1));
                return;
            }



        }


        return true;
    }


    function AjoutLigne(event) {
        var list = [];
        if (entities.length > 0) list = [...entities];
        list[list.length] = {
            idProduit: null,
            designation: null,
            code: null,
            valeur: null,
        };
        setEntities(list);
    }


    function listepp() {
        navigate.push(client + "/listImsNat");
    }


    const ProdParent = useCallback(
        async (b) => {
            var ImsNat = await dispatch(fetchProduit({client,view:"releve" }));
            var entities = ImsNat.payload;
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir un parent", style: "placeholder" });
            entities.forEach((a) => {
                arOption.push({ value: a.id, label: a.designation });
                if (a.id === b) {
                    setImsNatSelect({ value: a.id, label: a.designation });
                    setparent(a.id);
                }
            });
            setImsNatOptions(arOption);
        },
        [dispatch]
    );




    const hideAlert = () => {
        setAlert(null);
    };



    useEffect(() => {
        switch (month) {
            case 1:
                setVariable("JANVIER");
                break;
            case 2:
                setVariable("FEVRIER");
                break;
            case 3:
                setVariable("MARS");
                break;
            case 4:
                setVariable("AVRIL");
                break;
            case 5:
                setVariable("MAI");
                break;
            case 6:
                setVariable("JUIN");
                break;
            case 7:
                setVariable("JUILLET");
                break;
            case 8:
                setVariable("AOUT");
                break;
            case 9:
                setVariable("SEPTEMBRE");
                break;
            case 10:
                setVariable("OCTOBRE");
                break;
            case 11:
                setVariable("NOUVEMBRE");
                break;
            case 12:
                setVariable("DECEMBRE");
                break;
            default:
                break;
        }
        getproduit();
        ProdParent(0)
        verifmois()
        verifannee()
    }, []);


    function deleteLigne(id, entities) {
        var list = [...entities];
        if (list.length > 1) {
            entities.splice(parseInt(id), 1);
            setEntities(entities);
            notify(1, "Supprimer avec succes");
        } else {
            notify(2, "il faut contient au moins une ligne");
        }
        hideAlert();
    }


    const confirmMessage = (id, entities) => {
        setAlert(
            <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title="Êtes-vous sûr de supprimer cette ligne ?"
                onConfirm={() => deleteLigne(id, entities)}
                onCancel={() => hideAlert()}
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="danger"
                confirmBtnText="Oui"
                cancelBtnText="Non"
                showCancel
            ></SweetAlert>
        );
    };


    return (

        <>
            <Container fluid className="responsive-BL table-dynamique releve-class">
                <ToastContainer />
                {alert}
                <Row>
                    <Col md="12">
                        <Button
                            id="saveBL"
                            className="btn-wd btn-outline mr-1 float-left"
                            type="button"
                            variant="info"
                            onClick={listepp}
                        >
                            <span className="btn-label">
                                <i className="fas fa-list"></i>
                            </span>
                            Retour à la liste
                        </Button>
                    </Col>


                </Row>

                <Row>
                    <Col md="12">
                        <Card className="strpied-tabled-with-hover">
                            <Card.Header>
                                <Card.Title as="h3" style={{ textAlign: "center", color: "#0077af" }}><strong>{variable}</strong> </Card.Title>
                                <Row>
                                    <Col md="10">
                                        <Card.Title as="h4">Ims Nat</Card.Title>
                                    </Col>
                                    <Col md="2">
                                        <Button
                                            id="saveBL"
                                            className="btn-wd btn-outline mr-1 float-left"
                                            type="button"
                                            variant="info"
                                            onClick={() => {
                                                const moisTextuel = ["janv", "févr", "mars", "avr", "mai", "juin", "juil", "août", "sept", "oct", "nov", "déc"];
                                                const currentDate = new Date();
                                                const currentMonthIndex = currentDate.getMonth(); // 0-based
                                                const currentYearShort = currentDate.getFullYear().toString().slice(-2); // ex: "2025" -> "25"
                                                const dynamicKey = `${moisTextuel[currentMonthIndex]}-${currentYearShort}`; // Ex: "juil-25"

                                                exportToexcel([
                                                    {
                                                        "CODE": "",
                                                        "PRESENTATION": "",
                                                        "PRESENTATION IMS": "",
                                                        [dynamicKey]: ""
                                                    }
                                                ]);
                                            }}
                                        >
                                            <span className="btn-label">
                                                <i className="fas fa-upload"></i>
                                            </span>
                                            Télécharger exemple
                                        </Button>
                                    </Col>
                                </Row>

                            </Card.Header>
                            <Card.Body>



                                <Row>
                                    <Col className="pl-1" md="6">
                                        <Form.Group >
                                            <label>Mois</label>
                                            <Select
                                                placeholder="Mois "
                                                className="react-select primary "
                                                classNamePrefix="react-select"
                                                isDisabled={readonly === 1}
                                                value={moisSelect}
                                                onChange={(value) => {
                                                    setmoisSelect(value);
                                                    setmonth(value.value);
                                                }}
                                                options={optionsmois}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="pl-1" md="6">
                                        <Form.Group >
                                            <label>Année</label>
                                            <Select
                                                placeholder="Année "
                                                className="react-select primary "
                                                classNamePrefix="react-select"
                                                value={anneeSelect}
                                                isDisabled={readonly === 1}
                                                onChange={(value) => {
                                                    setanneeSelect(value);
                                                    setyear(value.value);
                                                }}
                                                options={optionsannee}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <br></br><br></br>

                                <Form.Group  >
                                    <Form.Control
                                        id="test"
                                        name="file"
                                        type="file" isDisabled={readonly === 1}
                                        accept=".xls, .xlsx"
                                        onChange={(e) => {
                                            fileHandler(e);
                                        }}
                                    ></Form.Control>
                                </Form.Group>

                                <br></br>
                                <br></br>
                                <div className="text-center" style={{ display: month != 0 && fileName != "" ? 'block' : 'none' }}>
                                    <Button
                                        className="btn-wd btn-outline mr-1 float-right imsnat"
                                        id="blExt"
                                        type="button"
                                        variant="info"
                                        style={{ display: readonly === 0 ? 'block' : 'none' }}
                                        onClick={(v) => {
                                            showTable();
                                            setIsLoading(1)
                                            setreadonly(1)
                                        }}
                                    >
                                        <span className="btn-label">
                                            <i className="fas fa-cogs"></i>
                                        </span>
                                        Extraction
                                    </Button>
                                </div>


                                <div className="loader-container" style={{ display: isLoading === 1 ? 'block' : 'none' }}>
                                    <div className="loader"></div>
                                </div>

                                <Row style={{ display: isLoading === 2 ? 'block' : 'none' }} >
                                    <Col md="12">
                                        <hr></hr>
                                        <br></br>

                                        <div className="div-sample1">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Présentation ims</th>
                                                        <th>Code</th>
                                                        <th>Valeur</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* {console.log(entities)} */}
                                                    {entities.map((row, key) => (

                                                        <tr key={"tr-" + key}>

                                                            <td>
                                                                {row.idProduit !== null ? (
                                                                    <Form.Group className="desinationProduit">
                                                                        <Form.Control
                                                                            className="green"
                                                                            readOnly
                                                                            value={row.designation}
                                                                            placeholder="Designation"
                                                                            type="text"
                                                                        />
                                                                        <Button
                                                                            onClick={() => {
                                                                                removeProduit(entities, produitSelect, key);
                                                                            }}
                                                                        >
                                                                            <i className="fa fa-trash" />
                                                                        </Button>
                                                                    </Form.Group>
                                                                ) : (
                                                                    <div >
                                                                        {row.designation != null ? (
                                                                            <Form.Group className="desinationProduit">
                                                                                <Form.Control
                                                                                    className="red"
                                                                                    readOnly
                                                                                    value={row.designation}
                                                                                    placeholder="Designation"
                                                                                    type="text"
                                                                                />
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        removeProduit(entities, produitSelect, key);
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-trash" />
                                                                                </Button>
                                                                            </Form.Group>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                        <Select
                                                                            className="react-select primary custom-react-select"
                                                                            classNamePrefix="react-select"
                                                                            name="Produit"
                                                                            placeholder="Produit"
                                                                            value={produitSelect[key]}
                                                                            onChange={(v) => {

                                                                                var e = entities;
                                                                                var select = produitSelect;
                                                                                e[key].idProduit = v.value;
                                                                                e[key].designation = v.label;
                                                                                e[key].code = v.code;
                                                                                select[key] = v;
                                                                                setProduitSelect(select);
                                                                                setEntities(e);
                                                                                setTable(e, 1);

                                                                            }}
                                                                            options={optionProduit}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <Form.Group>
                                                                    <Form.Control
                                                                        className="green"
                                                                        value={row.code}
                                                                        placeholder="Code"
                                                                        type="text"
                                                                        readOnly
                                                                    />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    className="green"
                                                                    value={row.valeur}
                                                                    placeholder="Valeur"
                                                                    type="text"
                                                                    onChange={(e) => {
                                                                        var list = [...entities];
                                                                        list[key].valeur = e.target.value;
                                                                        setEntities(list);
                                                                        setTable(list, 1);
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Button
                                                                    id={'idLigneR_' + key}
                                                                    onClick={(ev) => {
                                                                        confirmMessage(key, entities);
                                                                    }}
                                                                    variant="danger"
                                                                    size="sm"
                                                                    className="text-danger btn-link delete"
                                                                >
                                                                    <i className="fa fa-trash" id={'idLigneR_' + key} />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>

                                    <br></br>
                                    <hr></hr>
                                    <Button
                                        className="btn-fill pull-left"
                                        type="button"
                                        variant="info"
                                        nom="redac"
                                        onClick={(ev) => AjoutLigne()}
                                    >
                                        Ajouter
                                    </Button>
                                    <Col md="12">
                                        <Button
                                            id="saveBL"
                                            className="btn-wd btn-outline mr-1 float-right"
                                            type="button"
                                            variant="info"
                                            onClick={() =>
                                                saveTable(
                                                    entities,
                                                    uploadFile,
                                                    year,
                                                    month, client
                                                )
                                            }
                                        >
                                            <span className="btn-label">
                                                <i className="fas fa-check"></i>
                                            </span>
                                            Enregistrer
                                        </Button>
                                    </Col>
                                </Row>
                                {/* )} */}

                                <Row style={{ display: isLoading === 0 ? 'block' : 'none' }}>

                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default extraction_ImsNat;
